<template>
    <div class="gardener">
        <div class="garBanner">
            <a href="http://220.191.208.193/lishui_newtimes/frontend/web/gardener_test/?from=groupmessage#/home?app_token=1591231888517e5805fc5e1454d789ab934199f2a51f4&app_zyzid=151496689889018ed9461eab34222a71234c94b910443&nsukey=9Qd1cG8hjxVHgalbqbTMkKIQ4HvAtT3zWN1gBw0u7K0QaLG1abrJtE79HI7Z246AHE5RuDed%2FpnFM6YztF97VskvGv1fKpquywRdvBK%2FJHWbXN9uI9MIrtBnHcGKp1KtKbx%2B6vjI5hmLsh%2B%2BkKtx8w%3D%3D" target="_blank"><img src="../assets/images/yuanding.png"></a>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="less">
    .garBanner{
        width: 1200px;
        margin: 0 auto;
        img{
            width: 100%;
        }
    }
</style>